/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{width:260px}h5[_ngcontent-%COMP%]{font-size:10px;color:#8e8fa6;margin:0}div.row[_ngcontent-%COMP%]{margin-top:12px}.icon-wrapper[_ngcontent-%COMP%]{width:40px;height:40px;border:1px solid #d4d3db;border-radius:50%;margin-right:20px;display:flex;justify-content:center;align-items:center}.info[_ngcontent-%COMP%]{width:200px}.date[_ngcontent-%COMP%]{font-size:16px;color:#26273b}.details[_ngcontent-%COMP%]{font-size:14px;color:#8e8fa6}.date[_ngcontent-%COMP%], .details[_ngcontent-%COMP%]{display:block}"];
export { styles as styles };
